import EventsHelper from '../../../_helpers/events';
import { x0 } from '../../../_helpers';

export default class EditorialLiveUpdate {

  videoListContainer = null;
  photoListContainer = null;
  relatedStoriesContainer = null;
  
  constructor() {

    let _this = this;

    _this.videoListContainer = x0('.vbw-match-latest-videos');
    _this.photoListContainer = x0('.vbw-match-latest-photos');
    _this.relatedStoriesContainer = x0('.vbw-match-related-stories');

    
    EventsHelper.OnAjaxModuleLoaded(function () {
      _this.videoListContainer = x0('.vbw-match-latest-videos');
      _this.photoListContainer = x0('.vbw-match-latest-photos');
      _this.relatedStoriesContainer = x0('.vbw-match-related-stories');
    });

    EventsHelper.On('VideoListDataUpdate', function (data) {
      if (data.detail) {
        _this.updateVideoList(data.detail);
      }
    });

    EventsHelper.On('PhotoListDataUpdate', function (data) {
      if (data.detail) {
        _this.updatePhotoList(data.detail);
      }
    });

    EventsHelper.On('RelatedStoriesDataUpdate', function (data) {
      if (data.detail) {
        _this.updateRelatedStories(data.detail);
      }
    });
  }

  updateRelatedStories(content) {
    let _this = this;

    if (_this.relatedStoriesContainer) {
      _this.relatedStoriesContainer.innerHTML = content;
      EventsHelper.AjaxModuleLoaded();
    }
    
  }

  updatePhotoList(content) {
    let _this = this;
    if (_this.photoListContainer) {
      _this.photoListContainer.innerHTML = content;
      EventsHelper.AjaxModuleLoaded();
    }
    
  }

  updateVideoList(content) {
    let _this = this;
    if (_this.videoListContainer) {
      _this.videoListContainer.innerHTML = content;
      EventsHelper.AjaxModuleLoaded();
    }
  }
}

